import React from 'react'
import HeaderBlack from '../component/Header/HeaderBlack';
import ContactBlack from './ContactBlack';
import MapBlack from './MapBlack';
function ContactsBlack()
{
return(
    <>
<HeaderBlack/>
<ContactBlack/>
</>
);
}
export default ContactsBlack;